import { render } from "./DashboardSvgIcon.vue?vue&type=template&id=709faaf8"
import script from "./DashboardSvgIcon.vue?vue&type=script&lang=js"
export * from "./DashboardSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__